import React from "react";
import Navbarr from "./Navbar";
import Search from "./Search";

const Home = () => {
  return (
    <div>
      <Navbarr />
      <Search />
    </div>
  );
};

export default Home;
